export const workingHourConstants = {
    GET_REQUEST: 'GET_WORKLOG_LIST',
    GET_SUCCESS: 'GET_WORKLOG_SUCCESS',
    GET_FAILURE: 'GET_WORKLOG_FAILURE',

    ADD_SUCCESS: 'ADD_WORKLOG_SUCCESS',
    ADD_FAILURE: 'ADD_WORKLOG_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_WORKLOG_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_WORKLOG_FAILURE',

    DELETE_SUCCESS: 'DELETE_WORKLOG_SUCCESS',
    DELETE_FAILURE: 'DELETE_WORKLOG_FAILURE',

    GETAPPROVAL_SUCCESS: 'GETAPPROVAL_WORKLOG_SUCCESS',
    GETAPPROVAL_FAILURE: 'GETAPPROVAL_WORKLOG_FAILURE',

    CLEAR_ERROR: 'CLEAR_WORKLOG_ERROR_CODE',
    CLEAR_SUCCESS_CODE: 'CLEAR_WORKLOG_SUCCESS_CODE'
};
